export const LOGO_URL = "https://help.nflxext.com/helpcenter/OneTrust/oneTrust_production_2025-12-03/consent/87b6a5c0-0104-4e96-a291-092c11350111/019ae4b5-d8fb-7693-90ba-7a61d24a8837/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png"
export const AVATAR = 'https://wallpapers.com/images/high/netflix-profile-pictures-1000-x-1000-qo9h82134t9nv0j0.webp'
export const API_OPTIONS = {
  method: 'GET',
  headers: {
    accept: 'application/json',
    Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI4ZjUzZGY1ZjNiZDIzYWZkNGVlOTllYjU0ZTNkNDZjMiIsIm5iZiI6MTc2Njc0MDAwOS43MTgwMDAyLCJzdWIiOiI2OTRlNTAyOWNjNmY3NzgxYzFmYjBiZTciLCJzY29wZXMiOlsiYXBpX3JlYWQiXSwidmVyc2lvbiI6MX0.6FyECOwK1_hwK8ZYaf9MhSgpLSVWa3ajD7W_ATkSG0w'
  }
};
export const TMDB_IMAGE_CDN = "https://image.tmdb.org/t/p/w500"

export const BACKGROUND_IMG = "https://assets.nflxext.com/ffe/siteui/vlv3/8e4a7625-f942-48f5-a9b0-d470b772bc8c/web/IN-en-20251215-TRIFECTA-perspective_a8575e53-99ab-4f16-a2d6-c037acaf12a6_small.jpg"

export const LANGUAGE_OPTIONS = [
  {initializer: 'en' , name : 'English'},
  {initializer: 'hindi' , name : 'Hindi'},
  {initializer: 'spanish' , name : 'Spanish'}
]

export const OPENAI_KEY = ''